import { Hdc1Dot5MembershipProfileResponse } from "../../../types/responses";

export const getHdc1Dot5MembershipId = (
  id: string
): Hdc1Dot5MembershipProfileResponse => ({
  data: {
    membershipId: id,
  },
});
